import { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useMutation } from "@tanstack/react-query";

import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";
import DaysPicker from "@/Layouts/components/DaysPicker/DaysPicker";
import { errorLogger } from "@/Common/helpers/logger";
import Title from "../../../common/Title";

type TCitGraphWidthProps = {
	locationId: string;
	citGraphWidth?: string;
};

export default function CitGraphWidth(props: Readonly<TCitGraphWidthProps>) {
	const { locationId, citGraphWidth } = props;
	const [days, setDays] = useState<string>();

	const { mutate, isPending } = useMutation({
		mutationKey: ["systemSettings", locationId],
		mutationFn: (input: { citGraphWidth: string }) => updateSystemSettings(locationId, input, "CIT_GRAPH_WIDTH"),
		onError: (error) => errorLogger(error),
		onSuccess: (data) => {
			setDays(data.citGraphWidth);
		},
	});

	const updateData = (value: { id: number; label: string }) => mutate({ citGraphWidth: value["label"] });

	useEffect(() => {
		setDays(citGraphWidth);
	}, [citGraphWidth]);

	return (
		<Box className="!mt-[16px]">
			<Title title="CIT Graph Width" className="!mb-[24px]" />
			<Grid container className="border-none" columnSpacing={2} mb={3}>
				<Grid item xs={4}>
					<DaysPicker daysMax={31} initialValue={days} readOnly={isPending} updateData={updateData} name={"citGraphWidth"} />
				</Grid>
			</Grid>
		</Box>
	);
}
